/** Strip [Attached file(s): …] prefix stored on user messages. */
export function stripAttachedFilePrefix(content) {
  const s = (content || '').trim();
  const match = s.match(/^\[Attached files?:[^\]]+\]\s*\n+/i);
  return match ? s.slice(match[0].length).trim() : s;
}

export function downloadTeamAssistantTranscript(messages, filename = 'team-assistant-chat.md') {
  const lines = (messages || [])
    .filter((m) => m.role === 'user' || m.role === 'assistant' || m.role === 'system')
    .map((m) => {
      const who =
        m.role === 'assistant'
          ? 'Assistant'
          : m.role === 'system'
            ? 'Notice'
            : m.user?.name || 'Staff';
      const body = (m.content || '').trim();
      return `## ${who}\n\n${body}\n`;
    });

  const blob = new Blob([lines.join('\n---\n\n')], { type: 'text/markdown;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
